import {
  GlossariesApi,
  GlossariesUpdateGlossaryMetadataPostRequest,
  GlossariesUpsertGlossaryPostRequest,
  GlossaryFileSupportResponse,
  InitOverrideFunction,
} from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { GlossariesApiService } from "../ApiServices/GlossaryApiService";
import GenericService from "../GenericService";

export class GlossariesService extends GenericService<GlossariesApi, GlossariesApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, GlossariesApi, GlossariesApiService);
  }

  public uploadGlossaryFile(
    request: GlossariesUpsertGlossaryPostRequest,
    overrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.apiService.glossariesUpsertGlossaryPost(request, overrides);
  }

  public updateGlossaryMetadata(
    request: GlossariesUpdateGlossaryMetadataPostRequest,
    overrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.apiService.glossariesUpdateGlossaryMetadataPost(request, overrides);
  }

  public downloadGlossaryFile(glossaryId: string): Promise<Blob> {
    return this.apiService.glossariesDownloadGlossaryFileGet({ glossaryId });
  }

  public getGlossaryFileInfos(overrides?: RequestInit | InitOverrideFunction): Promise<GlossaryFileSupportResponse> {
    return this.apiService.glossariesGetGlossaryFileSupport(overrides);
  }

  public deleteGlossary(glossaryId: string): Promise<string> {
    return this.apiService.glossariesDeleteGlossaryFile({ glossaryId });
  }
}
